import api from './index'
import { axios, gateWayAxios } from '@/utils/request'
import Vue from 'vue'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: '/sys/login',
    method: 'post',
    data: parameter
  })
}

export function phoneLogin(parameter) {
  return axios({
    url: '/sys/phoneLogin',
    method: 'post',
    data: parameter
  })
}

export function casLogin(parameter) {
  return axios({
    url: '/cas/client/login',
    method: 'post',
    data: parameter
  })
}

export function extCasLogin(parameter) {
  return axios({
    url: '/cas/client/extLogin',
    method: 'post',
    data: parameter
  })
}

export function ssoMapLogin(parameter) {
  return axios({
    url: '/cas/client/mapByMobile',
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo() {
  return axios({
    url: '/api/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout(logoutToken) {
  return axios({
    url: '/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token':  logoutToken
    }
  })
}
export function tokenLogin(parameter) {
  return axios({
    url: '/sys/tokenLogin',
    method: 'get',
    data: parameter
  })
}
export function listByUser(parameter) {
  return axios({
    url: '/system/sysInfo/listByUser',
    method: 'get',
    data: parameter
  })
}
export function getTicket() {
  return gateWayAxios({
    url: '/user-center/owSso/auth/getTicket',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

